import { Component, ElementRef, inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CameraStream, WebRTCCamera } from '@services/camera';
import { FaceTracker } from '@services/face-tracker';
import { MediaPipeTrackingData } from '@services/media-pipe-tracker.service';

@Component({
  selector: 'lv-face-detection-check',
  templateUrl: './face-detection-check.component.html',
  styleUrls: ['./face-detection-check.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule]
})
export class FaceDetectionCheckComponent implements OnInit, OnDestroy {
  private faceTracker = inject(FaceTracker);
  private camera = new WebRTCCamera(640, 480);

  @ViewChild('container', { static: true }) container: ElementRef<HTMLDivElement>;
  @ViewChild('overlay', { static: true }) overlay: ElementRef<HTMLCanvasElement>;

  private stream: CameraStream;
  private videoElement: HTMLVideoElement;
  private canvasContext: CanvasRenderingContext2D;

  ngOnInit() {
    this.stream = this.camera.streamTo(this.container.nativeElement, () => this.startFaceTracking());
  }

  ngOnDestroy() {
    if (this.stream) {
      this.stream.stop();
    }
  }

  private async startFaceTracking() {
    this.videoElement = this.container.nativeElement.querySelector('video');
    this.setupOverlay();
    const tracker = await this.faceTracker.initialize();
    tracker.live = true;
    tracker.start(this.stream, (data) => this.onFaceData(data));
  }

  private setupOverlay() {
    const canvas = this.overlay.nativeElement;
    this.canvasContext = canvas.getContext('2d');
    canvas.width = this.videoElement.videoWidth;
    canvas.height = this.videoElement.videoHeight;
  }

  private onFaceData(data: MediaPipeTrackingData) {
    if (!this.canvasContext) {
      return;
    }

    this.canvasContext.clearRect(0, 0, this.overlay.nativeElement.width, this.overlay.nativeElement.height);

    if (data.faces) {
      data.faces.forEach((face) => {
        if (face.box) {
          this.canvasContext.strokeStyle = '#00ff00';
          this.canvasContext.lineWidth = 2;
          this.canvasContext.beginPath();
          this.canvasContext.rect(face.box.xMin, face.box.yMin, face.box.width, face.box.height);
          this.canvasContext.stroke();
        }

        if (face.keypoints) {
          this.canvasContext.fillStyle = '#ff0000';
          face.keypoints.forEach((keypoint) => {
            this.canvasContext.beginPath();
            this.canvasContext.arc(keypoint.x, keypoint.y, 3, 0, 2 * Math.PI);
            this.canvasContext.fill();
          });
        }
      });
    }
  }
}
